import { feedbackSections, EnquiryEntry } from "./ContactFormSections";

/** Retrieve category data to populate the dropdowns */
export const ContactFormDataV2: EnquiryEntry[] = Object.keys(feedbackSections).map((categoryName) => ({
    ...feedbackSections[categoryName],
    section: feedbackSections[categoryName].label
})) as EnquiryEntry[];